module.exports = __webpack_public_path__ + "img/cover7.5449b490.jpg";